import { render, staticRenderFns } from "./process-legal-basis-radios.vue?vue&type=template&id=6e801ea6"
import script from "./process-legal-basis-radios.vue?vue&type=script&lang=js"
export * from "./process-legal-basis-radios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports